<template>
    <div class="text-xs-center">
        <img :src="'/static/' + item.img" style="margin: 0 auto;" :srcset="'/static/' + item.retina + ' 2x'" />
        <p class="regular font-34 darker-grey mb-0">{{ item.name }}</p>
        <h4 class="book font-20 light-grey">{{ item.job }}</h4>
        <p v-if="showBio" class="light-grey menu-text regular pt-2" style="width:220px; margin: 0 auto; " v-text="item.bio"></p>
        <div class="pt-2">
            <a :href="item.fbLink" target="_blank" v-if="item.fbLink">
                <img src="/static/facebook-icon.png" class="d-inline-block pr-2"/>
            </a>
            <a :href="item.instagramLink" target="_blank" v-if="item.instagramLink">
                <img src="/static/instagram-icon.png" class="d-inline-block" :class="{'pr-1': item.ownUrl}"/>
            </a>
            <a :href="item.ownUrl" target="_blank" class="no-decoration" v-if="item.ownUrl">
               <v-icon size="30">launch</v-icon>
            </a>
        </div>
    </div>
</template>

<script>
    export default {
      props: ['item', 'show-bio']
    }
</script>



// WEBPACK FOOTER //
// src/components/Challenger.vue